export default {
    props: {
        pageSize: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            default: 0
        },
        pagerCount: {
            type: Number,
            default: 5
        },
        'current-page': {
            type: Number,
            default: 1
        }
    },
    computed: {
        pageSizeCpd: {
            get(){
                return this.pageSize
            },
            set(val){
                this.$emit('update:page-size', val)
            }
        },
        currentPageCpd: {
            get(){
                return this.currentPage
            },
            set(val){
                this.$emit('update:current-page', val)
            }
        }
    },
    methods: {
        currentPageHandle(currentPage){
            this.$emit('current-page', currentPage)
        },
        sizeChangeHandle(pageSize){
            this.$emit('page-size', pageSize)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js